<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <PmNoRealTaskLeftTree ref="PmNoRealTaskLeftTree" @resourceTreeClickEventPush="resourceTreeClickEventPush"></PmNoRealTaskLeftTree>
    </template>
    <template v-slot:right_view>
      <PmNoRealTaskRightList :queryParamsForResourceTreeClick="queryParamsForResourceTreeClick"></PmNoRealTaskRightList>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../../layouts/BasicLayout';
import PmNoRealTaskLeftTree from '../../../components/pmConfig/pproject/PmTaskManagementForP/Left/PmNoRealTaskLeftTree';
import PmNoRealTaskRightList from '../../../components/pmConfig/pproject/PmTaskManagementForP/Right/PmNoRealTaskRightList';

export default {
  name: 'PmNoRealTaskManagement',
  components: {
    BasicLayout,
    PmNoRealTaskLeftTree,
    PmNoRealTaskRightList
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t('Pm.exitTaskInfo')
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Pm.pmManagement')}/${this.$t('Pm.cycleMeasurement')}/${this.$t('Pm.noRealTaskManagement')}`
      },
      queryParamsForResourceTreeClick: {}
    };
  },
  methods: {
    // 网元树点击节点信息事件发布
    resourceTreeClickEventPush(params) {
      this.queryParamsForResourceTreeClick = params;
    }
  },
};
</script>

<style>

</style>
